import React from 'react';
import styled from 'styled-components';
import { TOKENIZER_PLATFORM_SECTORS } from '../../api/smartTokenizerMappers';

const CheckboxGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 0.75rem;
  margin-top: 0.35rem;
  max-height: min(52vh, 420px);
  overflow-y: auto;
  padding: 0.15rem 0.1rem 0.35rem 0;

  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.05);
    border-radius: 3px;
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(79, 172, 254, 0.35);
    border-radius: 3px;
  }

  .checkbox-item {
    display: flex;
    align-items: flex-start;
    gap: 0.75rem;
    padding: 0.85rem 0.9rem;
    background: rgba(255, 255, 255, 0.02);
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 10px;
    cursor: pointer;
    transition: border-color 0.2s ease, background 0.2s ease, box-shadow 0.2s ease;
    text-align: left;

    &:hover {
      background: rgba(255, 255, 255, 0.05);
      border-color: rgba(255, 255, 255, 0.18);
    }

    &.selected {
      border-color: #4facfe;
      background: rgba(79, 172, 254, 0.1);
      box-shadow: 0 0 0 1px rgba(79, 172, 254, 0.25);
    }

    input[type='checkbox'] {
      accent-color: #4facfe;
      margin-top: 0.15rem;
      flex-shrink: 0;
      width: 1rem;
      height: 1rem;
      cursor: pointer;
    }

    .item-info {
      flex: 1;
      min-width: 0;
    }

    .item-name {
      color: #fff;
      font-weight: 600;
      font-size: 0.9rem;
      margin-bottom: 0.3rem;
      line-height: 1.25;
    }

    .item-description {
      color: #a0a0a0;
      font-size: 0.78rem;
      line-height: 1.4;
    }
  }
`;

const FieldError = styled.div`
  font-size: 0.8rem;
  color: #ff6b6b;
  margin-top: 0.65rem;
`;

/**
 * Card grid for tokenization sectors (same UX as Authorized tokenizer → Authorized sectors).
 * @param {string[]} selectedIds — platform category ids (e.g. energy, realEstate)
 * @param {(id: string) => void} onToggle — toggle one sector id
 */
export function TokenizationSectorsCheckboxGrid({ selectedIds, onToggle, errorMessage }) {
  const ids = selectedIds ?? [];

  return (
    <>
      <CheckboxGrid role="group" aria-label="Tokenization sectors">
        {TOKENIZER_PLATFORM_SECTORS.map((category) => {
          const selected = ids.includes(category.id);
          return (
            <div
              key={category.id}
              className={`checkbox-item ${selected ? 'selected' : ''}`}
              onClick={() => onToggle(category.id)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  onToggle(category.id);
                }
              }}
              role="button"
              aria-pressed={selected}
              tabIndex={0}
            >
              <input
                type="checkbox"
                checked={selected}
                onChange={() => {}}
                tabIndex={-1}
                aria-hidden
              />
              <div className="item-info">
                <div className="item-name">
                  {category.icon} {category.name}
                </div>
                <div className="item-description">{category.description}</div>
              </div>
            </div>
          );
        })}
      </CheckboxGrid>
      {errorMessage ? <FieldError>{errorMessage}</FieldError> : null}
    </>
  );
}

export default TokenizationSectorsCheckboxGrid;
